module.exports = "https://cdn.hellotech.com/client-assets/home-front-mobile_e16f8c541604825467fabadf72d594c0.webp";